import * as yup from 'yup';
import { DICTONARY } from 'const/Dictonary';

const emailRegex = DICTONARY.EMAIL_REGEX;

const SchemaLogin = yup.object().shape({
  email: yup
    .string()
    .trim()
    .matches(emailRegex, 'El email no tiene el formato correcto')
    .required('ingrese un email'),
  password: yup.string().trim().required('ingrese una contraseña')
});

export { SchemaLogin };
